import React, { FC, memo, useState } from 'react'
import styled from 'styled-components'

import Chevron from '../../../common/components/Chevron'

import PartnerInfoCard from './PartnerInfoCard'

const SExpandElementContainer = styled.div`
    display: flex;
    margin-top: 30px;
`

const STitleContainer = styled.div`
    width: 200px;
`

const SChevronContainer = styled.div`
    padding-top: 3px;
    margin-left: 20px;
`

const STitleText = styled.label`
    width: 200px;
    font-size: 21px;
    font-weight: var(--font-weight-bold);
    line-height: 28px;
    margin-bottom: 0px;
    display: block;
    word-wrap: break-word;
`

const SSubTitleText = styled.label`
    font-size: 21px;
    font-weight: var(--font-weight-light);
    line-height: 28px;
    margin-bottom: 0px;
    word-wrap: break-word;
`

export type Props = {
    name?: string | null
    email?: string | null
    phone?: string | null
    chargerName?: string | null
    chargerSerialNumber?: string | null
}

const PartnerInfoItem: FC<Props> = ({ name, email, phone, chargerName, chargerSerialNumber }) => {
    const [isExpanded, setIsExpanded] = useState(false)

    if (!chargerSerialNumber) {
        return null
    }

    return (
        <>
            <SExpandElementContainer>
                <STitleContainer>
                    <STitleText data-testid="title-text-charger-name-partner-info">{chargerName}</STitleText>
                    <SSubTitleText data-testid="subtitle-text-charger-serial-number-partner-info">
                        {chargerSerialNumber}
                    </SSubTitleText>
                </STitleContainer>
                <SChevronContainer>
                    <Chevron flipped={isExpanded} onClick={() => setIsExpanded((prev) => !prev)} />
                </SChevronContainer>
            </SExpandElementContainer>

            {isExpanded ? <PartnerInfoCard name={name} email={email} phone={phone} /> : null}
        </>
    )
}

export default memo(PartnerInfoItem)
